import React from 'react';
import styled from 'styled-components';
import { Text, screenMdMin } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../Animations';
export const Headline = withAnimationContext(styled(Text).attrs({
    forwardedAs: 'h1',
    paddingBottom: 'looser-2',
    variant: 'titleLarge',
}) `
  ${fadeInAnimation(DELAYS.SECOND)};
  @media (min-width: ${screenMdMin}) {
    text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  }
`);
export const StyledSupertext = styled(Text).attrs({
    forwardedAs: 'h6',
    variant: 'bodyMedium',
}) `
  ${fadeInAnimation(DELAYS.FIRST)};
  text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  text-transform: uppercase;
  padding-bottom: 0px;
`;
export const Supertext = withAnimationContext(StyledSupertext);
export const HeadlineWithSupertextComponent = ({ supertext = '', headline = '', centered = false }) => {
    return (React.createElement("div", null,
        React.createElement(Supertext, { centered: centered }, supertext),
        headline && React.createElement(Headline, { centered: centered }, headline)));
};
